import React from 'react'
import NavBarTwo from '../Components/NavBarTwo'

function TermsOfService() {
  return (
    <div>
      <NavBarTwo />

      <div className="policy-container">
        <h1>Terms of Service</h1>
        <p>Last updated: December 29th 2025</p>

        <h2>1. Introduction</h2>
        <p>
          Welcome to Zindua App. These Terms of Service govern your access to and use of the Zindua platform, including our website, applications, and related services.
          By accessing or using Zindua, you agree to these Terms. If you do not agree, you must not use the platform.
        </p>

        <h2>2. Definitions</h2>
        <p>
          “Platform” refers to Zindua App and all related services.
          “User” means any person or entity using the platform.
          “Creator” refers to influencers or content creators offering services.
          “Brand” refers to businesses or individuals engaging creators.
          “Content” includes text, images, videos, campaigns, and other materials uploaded or shared on the platform.
        </p>

        <h2>3. Eligibility</h2>
        <p>
          You must be at least 18 years old to use Zindua App. By using the platform, you confirm that you have the legal capacity to enter into binding agreements under the laws of Kenya.
        </p>

        <h2>4. Account Registration</h2>
        <p>
          To access certain features, you must create an account and provide accurate, complete, and current information.
          You are responsible for safeguarding your account credentials and all activity that occurs under your account.
        </p>

        <h2>5. Platform Role</h2>
        <p>
          Zindua App acts as a technology platform that connects brands and creators. Zindua App is not a party to agreements between brands and creators and does not guarantee campaign outcomes, engagement levels, or revenue.
        </p>

        <h2>6. Creator Responsibilities</h2>
        <p>
          Creators are responsible for the accuracy of their profiles, service descriptions, pricing, and delivery of agreed services.
          Creators must comply with all applicable laws, platform policies, and third party platform rules when delivering campaigns or subscriptions.
        </p>

        <h2>7. Brand Responsibilities</h2>
        <p>
          Brands are responsible for campaign content, instructions, and ensuring compliance with advertising laws and regulations.
          Brands must provide accurate information and respect agreed timelines and payments.
        </p>

        <h2>8. Campaigns and Subscriptions</h2>
        <p>
          Brands may run single campaigns or bulk campaigns across multiple creators.
          Subscriptions allow brands or users to access creator services on a recurring monthly basis, as defined by each creator.
          Zindua App does not guarantee performance results or business outcomes.
        </p>

        <h2>9. Payments and Fees</h2>
        <p>
          Zindua App does not charge brands a platform access fee.
          Payments made on the platform relate to campaigns, subscriptions, or creator services.
          Applicable transaction or service fees may be deducted and will be disclosed before payment.
        </p>

        <h2>10. Refunds and Disputes</h2>
        <p>
          Refunds are handled on a case by case basis depending on service delivery status.
          Zindua App may assist in dispute resolution but does not guarantee specific outcomes.
          Users agree to act in good faith when raising disputes.
        </p>

        <h2>11. Content Ownership</h2>
        <p>
          Users retain ownership of content they upload.
          By uploading content, you grant Zindua App a non exclusive, royalty free license to use, display, and promote such content for platform operations and marketing purposes.
        </p>

        <h2>12. Prohibited Conduct</h2>
        <ul>
          <li>Providing false or misleading information</li>
          <li>Violating laws or third party rights</li>
          <li>Uploading harmful, abusive, or illegal content</li>
          <li>Attempting to bypass platform payment systems</li>
          <li>Using the platform for fraudulent purposes</li>
        </ul>

        <h2>13. Suspension and Termination</h2>
        <p>
          Zindua App may suspend or terminate accounts that violate these Terms or applicable laws.
          Users may terminate their accounts at any time by contacting support.
        </p>

        <h2>14. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Zindua App shall not be liable for indirect, incidental, or consequential damages arising from use of the platform.
        </p>

        <h2>15. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Zindua App from claims arising out of your use of the platform, violation of these Terms, or infringement of third party rights.
        </p>

        <h2>16. Privacy</h2>
        <p>
          Your use of Zindua App is subject to our Privacy Policy, which explains how we collect, use, and protect personal data in accordance with the Kenya Data Protection Act, 2019.
        </p>

        <h2>17. Changes to These Terms</h2>
        <p>
          Zindua App may update these Terms from time to time. Continued use of the platform after changes means you accept the updated Terms.
        </p>

        <h2>18. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the Republic of Kenya. Any disputes shall be resolved in Kenyan courts.
        </p>

        <h2>19. Contact Information</h2>
        <p>
          If you have questions about these Terms, please contact us through the Zindua App platform.
        </p>
      </div>
    </div>
  )
}

export default TermsOfService